 
const suMenu = [
  {
    System: 'SU',
    isActive: true,
    menu: [
      { is_header: true, title: 'SupportingUnits', isActive: true },
 
            {
        path: '/SU/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      {
        path: '/SU/RealEstate',
        icon: 'bi bi-buildings',
        title: 'RealEstate',
        isActive: true
      },
      {
        path: '/SU/SU_ExtraInformationDynamicType',
        icon: 'bi bi-building-gear',
        title: 'Types_Real_Estate',
        isActive: true
      },
      {
        path: '/SU/Contracts',
        icon: 'bi bi-newspaper',
        title: 'RealEstateContracts',
        isActive: true
      },



      // New Owners and Tenants Section
      { is_header: true, title: 'إدارة الأطراف', isActive: true },
      {
        path: '/SU/Owners',
        icon: 'bi bi-person-badge', // أو bi bi-person-vcard
        title: 'الملاك',
        isActive: true,
        permission: 'SU_Owners_View'
      },
      {
        path: '/SU/Tenants',
        icon: 'bi bi-people', // أو bi bi-person-arms-up
        title: 'المستأجرين',
        isActive: true,
        permission: 'SU_Tenants_View'
      },

      { is_header: true, title: 'متابعة الإيجارات', isActive: true },

      {
        path: '/SU/FollowPayments/InstallmentUnPayment',
        title: 'دفع الأقساط',
        icon: 'bi bi-cash-coin',
        isActive: true
      },
      {
        path: '/SU/FollowPayments/InstallmentPayment',
        title: 'عرص الأقساط المدفوعة',
        icon: 'bi bi-clipboard-check',
        isActive: true
      },

      // Maintenance Section
      { is_header: true, title: 'إدارة الصيانة', isActive: true },
      {
        path: '/SU/MaintenanceOrders',
        icon: 'bi bi-tools', //  
        title: 'أوامر الصيانة',
        isActive: true,
        permission: 'SU_Maintenance_View'
      },

      { is_header: true, title: 'Settings', isActive: true },

      {
        path: '/SUSettings/Branches',
        icon: 'bi bi-diagram-3', // شبكة الفروع
        title: 'وحدات التشغيـل',
        isActive: true
      },
      {
        path: '/SUSettings/Branches',
        icon: 'bi bi-people', // شبكة الفروع
        title: 'المقاولين',
        isActive: true
      },

      {
        path: '/SUSettings/Locations',
        icon: 'bi bi-geo-alt', // موقع على الخريطة
        title: 'Locations',
        isActive: true
      },

      { is_header: true, title: 'Reports', isActive: true },
      {
        path: '/SU/Reports',
        icon: 'bi bi-people',
        title: 'Reports',
        isActive: true
      },
      {
        path: '',
        icon: 'bi bi-cpu',
        title: 'لوحة البيانات',
        isActive: true
      }
    ]
  }
];

export default suMenu;
